import { LinkV2, SpacingStack, StyleSystemProps, styled } from '@withjoy/joykit';

export const EventDetailsWrapper = styled(SpacingStack)`
  max-width: 512px;
  position: relative;
  ${props => props.theme.mediaQueries.up({ viewport: 'sm' })} {
    border-radius: ${props => props.theme.space[6]};
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07), 0px 7px 27px 0px rgba(44, 41, 37, 0.06);
  }
`;

export const StyledLinkV2 = styled(LinkV2)`
  text-decoration-color: ${({ theme }) => theme.colors.mono5};
  :hover {
    text-decoration-color: ${({ theme }) => theme.colors.mono8};
  }
  :visited,
  :active {
    text-decoration-color: ${({ theme }) => theme.colors.mono14};
  }
`;

export const LottieWrapper = styled.div`
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  width: 95vw;
  position: absolute;
  overflow: hidden;
  svg {
    scale: 1.5;
  }
  ${props => props.theme.mediaQueries.up({ viewport: 'md' })} {
    width: 80vw;
    svg {
      scale: 1;
    }
  }
`;

const signOutLinkStyles: StyleSystemProps = {
  display: 'inline-block',
  color: 'mono14',
  _hover: {
    color: 'mono8'
  }
};

export const styles = {
  signOutLinkStyles
};
